import CryptoJS from 'crypto-js'

// 加密密钥（需要与后端保持一致，必须是16/24/32字节）
const ENCRYPTION_KEY = 'tempWorkerSystem2026SecretKey!!!' // 32字节密钥

/**
 * AES加密（ECB模式，PKCS5填充）
 * @param {Object|string} data - 要加密的数据
 * @returns {string} 加密后的字符串（Base64编码）
 */
export function encrypt(data) {
  try {
    // 将数据转换为JSON字符串
    const jsonData = typeof data === 'string' ? data : JSON.stringify(data)
    
    // 将密钥转换为WordArray
    const key = CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY)
    
    // 使用AES-ECB模式加密
    const encrypted = CryptoJS.AES.encrypt(jsonData, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    
    // 返回Base64编码的密文
    return encrypted.ciphertext.toString(CryptoJS.enc.Base64)
  } catch (error) {
    console.error('加密失败:', error)
    throw new Error('数据加密失败')
  }
}

/**
 * AES解密（ECB模式，PKCS5填充）
 * @param {string} encryptedData - 加密的字符串（Base64编码）
 * @returns {Object|string} 解密后的数据
 */
export function decrypt(encryptedData) {
  try {
    // 将密钥转换为WordArray
    const key = CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY)
    
    // 将Base64密文转换为CipherParams
    const ciphertext = CryptoJS.enc.Base64.parse(encryptedData)
    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: ciphertext
    })
    
    // 使用AES-ECB模式解密
    const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    
    // 转换为字符串
    const jsonString = decrypted.toString(CryptoJS.enc.Utf8)
    
    if (!jsonString) {
      throw new Error('解密结果为空')
    }
    
    // 尝试解析为JSON，如果失败则返回原始字符串
    try {
      return JSON.parse(jsonString)
    } catch {
      return jsonString
    }
  } catch (error) {
    console.error('解密失败:', error)
    throw new Error('数据解密失败')
  }
}
